/**
 * Constants for Batch Payments feature
 */

// Payment method identifiers
export const PAYMENT_METHODS = {
  ACH: 'ACH',
  CC: 'CC',
  EFT: 'EFT', // CA bank
  BANK: 'BANK',
} as const;

// Enabled payment method types from wallet
export const ENABLED_PAYMENT_METHOD_TYPES = {
  BANK: 'bank',
  EFT: 'eft', // CA bank
  CREDIT_CARD: 'cc',
  DEBIT_CARD: 'dc',
  DEBIT_CREDIT: 'dc,cc',
} as const;

// Batch payment invoice selection behavior
export enum BATCH_PAYMENT_INVOICE_SELECTION {
  DEFAULT_INVOICE_ONLY = 'DEFAULT_INVOICE_ONLY',
  ALL_IN_SAME_TABLE = 'ALL_IN_SAME_TABLE',
}
